import { useLogout } from "@hooks/useLogout";
import {
  BottomSheetActionLayout,
  BottomSheetSubmitButton,
} from "@utils/swmModal/components/BottomSheetPrimitives";
import AppModalSheet from "@utils/appModal/components/AppModalSheet";
import { forwardRef } from "react";
import { type SheetAdapterRef } from "react-native-bottom-sheet-stack";

const LogoutModalSWM = ({ closeModal }: { closeModal: () => void }) => {
  const logout = useLogout(LogoutModalSWM.name);

  return (
    <BottomSheetActionLayout
      iconType="error"
      title="Logout account"
      subtitle="Are you sure you want to logout? Once you logout, you need to login again."
      actions={
        <BottomSheetSubmitButton
          sentryEventName="logout_modal_confirm"
          label="YES, LOGOUT"
          accessibilityLabel="YES, LOGOUT"
          testID="logout-modal-confirm"
          onPress={async () => {
            await logout();
            closeModal();
          }}
        />
      }
    />
  );
};

export const LogoutModalSWMSheet = forwardRef<SheetAdapterRef>(
  function LogoutModalSWMSheet(_props, ref) {
    return (
      <AppModalSheet ref={ref} showHandle={false}>
        {({ closeModal }) => <LogoutModalSWM closeModal={closeModal} />}
      </AppModalSheet>
    );
  },
);

export default LogoutModalSWM;
